var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7363 0.0273438C11.9739 0.0273438 11.2114 0.315996 10.6367 0.890625L0.890637 10.6367C-0.287605 11.815 -0.319149 13.7805 0.937512 14.8809L5.16603 19.1113C6.31529 20.2606 8.21599 20.2606 9.36525 19.1113L19.1113 9.36523C20.2606 8.21598 20.2606 6.31527 19.1113 5.16602L14.8359 0.890625C14.2613 0.315996 13.4988 0.0273437 12.7363 0.0273438ZM12.7363 1.97266C12.9684 1.97266 13.1986 2.08332 13.4199 2.30469L17.6973 6.58008C18.14 7.02282 18.14 7.50843 17.6973 7.95117L7.95118 17.6973C7.50844 18.14 7.02283 18.14 6.58009 17.6973L2.28126 13.3984L2.25587 13.375C1.92102 13.0818 1.89034 12.4627 2.30275 12.0508H2.3047L3.52736 10.8281L6.55665 13.9316L7.98829 12.5352L4.94142 9.41406L6.51173 7.84375L8.084 9.5332L9.54884 8.16992L7.92775 6.42773L9.53712 4.81836L12.6328 7.91406L14.0469 6.49805L10.9531 3.40234L12.0508 2.30469C12.2722 2.08332 12.5043 1.97266 12.7363 1.97266Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.db4eaa99edb36d18da44b183a7bcc6ae.svg";
export { ForwardRef as ReactComponent };